import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const PortfolioDetailPage = lazy(() => import('../pages/portfolio/[id]/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PolicyPage = lazy(() => import('../pages/policies/page'));
const AITwinPage = lazy(() => import('../pages/ai-twin/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/portfolio/:id',
    element: <PortfolioDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/ai-twin',
    element: <AITwinPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/privacy-policy',
    element: <PolicyPage />,
  },
  {
    path: '/cookie-policy',
    element: <PolicyPage />,
  },
  {
    path: '/terms-of-use',
    element: <PolicyPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
